import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    containerButton: {
        marginBottom: '16px', marginTop: '20px'
    },
}));
